import { ProductionEnvironment as ImportedProductionEnvironment } from "@packages/config";
import type { Config } from "../config.contract";

export class ProductionEnvironment
  extends ImportedProductionEnvironment
  implements Config
{
  // Favorites usa a mesma propriedade Adobe Launch da garagem (dd5a99595f9f),
  // distinta da propriedade padrão do next.ui (home/search).
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/dd5a99595f9f/launch-03755baa3a1f.min.js";
  enableDatadog = true;
  traceSampleRate = 100;
  sessionSampleRate = 5;
  sessionReplaySampleRate = 5;
}
